import type React from "react";
import { setOnboardingLayoutTestId } from "./onboarding-layout.utils";

interface OnboardingLayoutProps {
  children: React.ReactNode;
  testId?: string;
}

export function OnboardingLayout({ children, testId }: OnboardingLayoutProps) {
  return (
    <div
      data-testid={testId ?? setOnboardingLayoutTestId("container")}
      className="min-h-screen bg-[#FAF6F3]"
    >
      <header
        data-testid={setOnboardingLayoutTestId("header")}
        className="border-b border-border-subtle bg-white"
      >
        <div className="container mx-auto px-6 py-4">
          <img src="/images/image.png" alt="Beanz" className="h-8" />
        </div>
      </header>
      <main
        data-testid={setOnboardingLayoutTestId("main")}
        className="container mx-auto px-6 py-12"
      >
        <div className="mx-auto max-w-5xl">{children}</div>
      </main>
    </div>
  );
}
